export default "__VITE_ASSET__3c0b6440__"